import React, { useEffect, useState } from "react";
import Icons from "./Icons";

// This component renders a "Back to Top" button that appears when the user scrolls down the page.
const BackToTop = () => {
  // State to keep track of the button's visibility
  const [isBackTopVisible, setIsBackTopVisible] = useState(false);

  useEffect(() => {
    // Function to check the scroll position and set the visibility state of the button
    const handleOffset = () => {
      if (window.pageYOffset > 100) {
        setIsBackTopVisible(true);
      } else {
        setIsBackTopVisible(false);
      }
    };

    // Add an event listener to the window to monitor the scroll position
    window.addEventListener("scroll", handleOffset);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener("scroll", handleOffset);
    };
  }, []);

  // Function to scroll the page to the top when the button is clicked
  const handleScroll = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div
      onClick={handleScroll}
      // Classes to style the button, including its visibility based on the state
      className={`group fixed bottom-5 right-5 z-40 cursor-pointer rounded-full border border-solid transition-all duration-300 ease-in-out border-black bg-white p-2 xl:p-3 hover:scale-110 hover:shadow-hover-white ${
        isBackTopVisible ? "translate-y-0" : "translate-y-20"
      }`}
    >
      {/* Icon for the button */}
      <Icons icon="top" className="size-5 xl:size-7 2xl:size-9 " />
    </div>
  );
};

export default BackToTop;
